'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typographicCurrency;

var _typographicCurrencyDb = require('typographic-currency-db');

var _typographicCurrencyDb2 = _interopRequireDefault(_typographicCurrencyDb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pattern = function pattern(key) {
  return new RegExp('([^a-z]|\\b)(' + key + ')\\b', 'gi');
};

function typographicCurrency(input) {
  if (!input) return;
  return Object.keys(_typographicCurrencyDb2.default).reduce(function (state, key) {
    return state.replace(pattern(key), '$1' + _typographicCurrencyDb2.default[key]);
  }, input);
};
